module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAATxJREFUWEftl9ENwjAMRH0TwAiMABMUNoENYBLYANiADWADGIERygRGRnaVRm1TkaSVEPnqR5t7uXOcBjTywMj6VANg5jkRTTJDvQA8TKMCUPF7ZnGbfmEQLsCSiK4DAawA3ESrDWBHRJVNiaAk3r3OFQSoXkgkTszsOvwH+HEHmHlNRAWAjdXQYDWg4kcVPhnEIACeuDCcAYgb8buAmacAyrZt2SUeDSDi2iUfbq5OvrJKs7228iQ1wMzSNgs/V11ZUDyFA9JGBcJOyk9xhWx344ouQj0tXQh5lvZqoyq4pjqJBlAbfSd6iUdH4FnpQ3SuPEkR+pY6cVxsn4dOzSQReE7MADxDwlkc6CuadBd8I/oHiHFgm+mn9KBQwT+i2MhD3zcCSIMZ72LitFo5enOOsvFqllOxa+7Rb8dvehxCMG6RFBAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/proIcon/pro1-2.png
// module id = RMFd
// module chunks = 3